export function publishedAccountIds(post) {
  return new Set([
    ...(post?.publishedAccounts || []).map((a) => a.socialAccountId),
    ...(post?.publishSummary?.targets || []).filter((t) => t.status === 'published').map((t) => t.socialAccountId),
  ].filter(Boolean));
}

export function initialPostAccounts({ post, accounts, targetIdHint, platformHint }) {
  const targets = post?.publishSummary?.targets || [];
  const published = publishedAccountIds(post);
  const available = (id) => accounts.some((a) => a.id === id) && !published.has(id);
  const hinted = targets.find((t) => t.id === targetIdHint);
  // An explicit published target stays unselected; never fall through and
  // select an unrelated account when opening that target's editor.
  if (hinted?.socialAccountId && accounts.some((a) => a.id === hinted.socialAccountId)) {
    return new Set(available(hinted.socialAccountId) ? [hinted.socialAccountId] : []);
  }
  const candidates = targets.length
    ? targets.map((t) => t.socialAccountId)
    : post?.job?.targetAccountIds || [];
  const selected = new Set(candidates.filter((id) => available(id)
    && (!platformHint || accounts.find((a) => a.id === id)?.platform === platformHint)));
  // Only a never-published draft gets the originating-platform fallback.
  if (!selected.size && !published.size && !targets.length) {
    const intended = new Set((post?.job?.platforms || []).map((p) => String(p).toLowerCase()));
    accounts.forEach((a) => {
      if (intended.has(a.platform) && (!platformHint || a.platform === platformHint)) selected.add(a.id);
    });
  }
  return selected;
}

export function scheduleTimeError(mode, value, now = Date.now()) {
  if (mode !== 'scheduled') return null;
  const time = new Date(value).getTime();
  if (!Number.isFinite(time)) return 'invalidDate';
  return time <= now ? 'timePassedHint' : null;
}

export function requiresNewSchedule(existingTargets, selectedTargets, publishedIds) {
  const existingIds = new Set(existingTargets.map((t) => t.socialAccountId));
  return selectedTargets.some((t) => publishedIds.has(t.socialAccountId) || !existingIds.has(t.socialAccountId));
}
